// extracted by mini-css-extract-plugin
export default {"root":"ScrollContainer_root__2BKbr"};